import { AuditLogsList } from 'src/app/audit-log/components/AuditLogsList';
import { useTrailer } from './trailerContext';

export const TrailerAuditLogs = () => {
  const { trailer } = useTrailer();

  return <AuditLogsList filter={{ trailerId: trailer.id }} />;
};
